import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr } from "../../Helper/ToastMessage";

// Get Table Data
export const DailyWorkSheetTableDataAPI = createAsyncThunk("DailyWorkSheetTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_AssetTypeID,
        M_DepartmentID,
        OfficerNameID,
        M_DesignationID,
        token,
        M_UserID,
        From,
        To,
        M_ZoneID,
        M_WardID
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_GD_T_DailyWork_Select?FromDate=${FromDate}&ToDate=${ToDate}&M_AssetTypeID=${M_AssetTypeID}&M_DepartmentID=${M_DepartmentID}&OfficerNameID=${OfficerNameID}&M_DesignationID=${M_DesignationID}&M_ZoneID=${M_ZoneID}&M_WardID=${M_WardID}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                // handleGetPdfUrl(result.url)
                return result.data
            } else {
                return result
            }
        })
})

const DailyWorkSheetTableDataSlice = createSlice({
    name: "DailyWorkSheetTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DailyWorkSheetTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(DailyWorkSheetTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(DailyWorkSheetTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const DailyWorkSheetTableDataReducer = DailyWorkSheetTableDataSlice.reducer

// PDF Report

export const DailyWorkSheetTablePDFDataAPI = createAsyncThunk("DailyWorkSheetTablePDFData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_AssetTypeID,
        M_DepartmentID,
        OfficerNameID,
        M_DesignationID,
        token,
        M_UserID,
        From,
        To,
        handleGetPDFReportUrl,
        M_ZoneID,
        M_WardID,
        Flag
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_RM_GD_T_DailyWork_Wise_CheckList_Select?FromDate=${FromDate}&ToDate=${ToDate}&M_AssetTypeID=${M_AssetTypeID}&M_DepartmentID=${M_DepartmentID}&OfficerNameID=${OfficerNameID}&M_DesignationID=${M_DesignationID}&M_ZoneID=${M_ZoneID}&M_WardID=${M_WardID}&M_UserID=${M_UserID}&From=${From}&To=${To}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleGetPDFReportUrl(result.url)
                return result.data
            } else {
                handleGetPDFReportUrl(result.url)
                return result
            }
        })
})

const DailyWorkSheetTablePDFDataSlice = createSlice({
    name: "DailyWorkSheetTablePDFData",
    initialState: {
        isPDFLoading: false,
        pdfData : null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DailyWorkSheetTablePDFDataAPI.pending, (state, action) => {
            state.isPDFLoading = true;
        });
        builder.addCase(DailyWorkSheetTablePDFDataAPI.fulfilled, (state, action) => {
            state.isPDFLoading = false;
            state.pdfData  = action.payload;
        });
        builder.addCase(DailyWorkSheetTablePDFDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPDFLoading = false;
            state.isError = true;
            state.pdfData  = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const DailyWorkSheetTablePDFDataReducer = DailyWorkSheetTablePDFDataSlice.reducer
